import { IField } from 'app/services/api5-service/api.interface';

import {
  getTypeControlForReflect,
  ReflectControl,
} from './get-typed-control-for-reflect';

/**
 * Map control metadata to typed object with value from doc state
 *
 * @param field - field metadata
 */
export function getTypeControlsForReflect(field: IField): ReflectControl[] {
  return (field.reflect || []).map(control =>
    getTypeControlForReflect(control),
  );
}
